export const IMMEDIATE_PROBLEM_TYPE = {
    debt: {
        en: 'Unaffordable debt',
        es: 'Deuda inasequible'
    },
    timing: {
        en: 'Matching up timing of revenue and expenses',
        es: 'Ajustar el calendario de ingresos y gastos'
    },
    expenses: {
        en: 'Unexpected expenses',
        es: 'Gastos inesperados'
    },
    other_problem: {
        en: 'Other financial problem',
        es: 'Otro problema financiero'
    }
} as Record<string, { en: string; es: string }>;
